<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-09 10:18:07
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-26 10:58:50
 * @FilePath: \合联\oms\src\view\analysis\gccOrderStatistics\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="height: 100%; background: white; padding: 10px">
    <Tabs v-model="tab" @on-click="tabChange">
      <TabPane
        v-for="item in tabs"
        :label="item.label"
        :name="item.value"
        :key="item.value"
      >
        <Order
          style="height: calc(100vh - 200px)"
          v-if="item.order"
          :data="tabsData[item.value]"
          :headers="header"
          :name="item.label"
          :ref="item.value"
        ></Order>
        <component
          :name="item.label"
          :headers="header"
          :is="item.value"
          v-else
          :ref="item.value"
        ></component>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import Order from "./order";
import { apis } from "@/api/analysis/gccOrderStatistics";
import country from "./country";
import province from "./province";
import city from "./city";
import { optionsApi, optionsCommonApi } from "@/libs/api.request.js";

export default {
  name: "gccOrderStatistics",
  components: {
    Order,
    country,
    province,
    city
  },
  mounted() {
    optionsCommonApi(
      this.header.reduce((a, b) => {
        if (b.options && !b.options.length) {
          console.log(b.optionsKey, b.optionsFn, b.options);
          b.optionsKey && a.set(b, b.optionsKey);
          b.optionsFn && optionsApi(b, b.optionsFn);
        }
        return a;
      }, new Map())
    );
    this.tabChange(this.tab);
  },
  methods: {
    tabChange(e) {
      console.log(e, this.$refs);
      if (this.$refs[e][0].init) return;
      this.$refs[e][0].init = true;
      this.$refs[e][0].$refs.table.getList();
    }
  },
  data() {
    return {
      tab: "order",
      tabs: [
        {
          label: this.$tz("订单,统计"),
          order: true,
          value: "order"
        },
        {
          label: this.$tz("时效,统计"),
          order: true,
          value: "time"
        },
        {
          label: this.$tz("达成率,统计"),
          order: true,
          value: "rate"
        },
        {
          label: this.$tz("主状态,统计"),
          order: true,
          value: "status"
        },
        {
          label: this.$tz("首派,分析"),
          order: true,
          value: "delivery_first"
        },
        {
          label: this.$tz("最后,派送,分析"),
          order: true,
          value: "delivery_new"
        },
        {
          label: this.$tz("正向,派送"),
          order: true,
          value: "tracker"
        },
        {
          label: this.$tz("逆向,取件"),
          order: true,
          value: "pickup"
        },
        {
          label: this.$tz("国家,统计"),
          value: "country"
        },
        {
          label: this.$tz("省份,统计"),
          value: "province"
        },
        {
          label: this.$tz("城市,统计"),
          value: "city"
        }
      ],
      tabsData: {
        order: {
          list: apis.order,
          keys: {
            num: { type: "string", description: "创建单量" },
            inbound_num: { type: "string", description: "入库单量" },
            outbound_num: { type: "string", description: "出库单量" },
            lj_num1: { type: "string", description: "拦截单量（未出库）" },
            lj_num2: { type: "string", description: "拦截单量（已出库）" },
            depart_num: { type: "string", description: "起飞单量" },
            arrival_num: { type: "string", description: "航班到达单量" },
            clearance_num: { type: "string", description: "清关完成单量" },
            c_num: { type: "string", description: "海外入仓单量" },
            transport_num: { type: "string", description: "RDC仓转运单量" },
            delivery_num: { type: "string", description: "首次派送单量" },
            reservation_num: {
              type: "string",
              description: "预约派送单量"
            },
            abnormal_num: { type: "string", description: "异常单量" },
            fail_num: { type: "string", description: "未签收单量" },
            pod_num: { type: "string", description: "签收单量" },
            delivery_rate: { type: "string", description: "首派率" },
            delivery7_rate: {
              type: "string",
              description: "入库-首派7天达成率"
            },
            pod8_rate: {
              type: "string",
              description: "入库-签收8天达成率"
            },
            fail_rate: { type: "string", description: "签收失败率" },
            pod_rate: { type: "string", description: "签收成功率" },
            cod_rate: { type: "string", description: "COD占比" }
          }
        },
        time: {
          list: apis.time,
          keys: {
            num: { type: "string", description: "出库单量" },
            inbound_h: { type: "string", description: "创建至入库" },
            outbound_h: { type: "string", description: "入库至出库" },
            instation_h: {
              type: "string",
              description: "出库至香港仓/机场仓"
            },
            port_h: {
              type: "string",
              description: "香港仓/机场仓至交航"
            },
            depart_h: { type: "string", description: "交航至起飞" },
            depart_h1: { type: "string", description: "入库至起飞" },
            arrival_h: { type: "string", description: "起飞至抵达" },
            clearance_h: {
              type: "string",
              description: "抵达至清关完成"
            },
            c_h: { type: "string", description: "清关完成至海外入仓" },
            c_h1: { type: "string", description: "抵达至海外入仓" },
            transport_h: {
              type: "string",
              description: "海外入仓至转运"
            },
            hub_h: {
              type: "string",
              description: "转运到派送站点入库"
            },
            delivery1_h: {
              type: "string",
              description: "派送站点入库到首派"
            },
            delivery_h: { type: "string", description: "入库至首派" },
            pod_h: { type: "string", description: "入库至签收" }
          }
        },
        rate: {
          list: apis.rate,
          keys: {
            num: { type: "string", description: "出库单量" },
            inbound_rate: {
              type: "string",
              description: "创建至入库24h达成率"
            },
            outbound_rate: {
              type: "string",
              description: "入库至出库8h达成率"
            },
            depart_rate: {
              type: "string",
              description: "入库至起飞60h达成率"
            },
            clearance_rate: {
              type: "string",
              description: "抵达至清关完成10h达成率"
            },
            c_rate: {
              type: "string",
              description: "清关完成至海外入仓8h达成率"
            },
            hub_rate: {
              type: "string",
              description: "海外入仓至派送站点入库36h达成率"
            },
            delivery1_rate: {
              type: "string",
              description: "派送站点入库到首派24h达成率"
            },
            delivery7_rate: {
              type: "string",
              description: "入库至首派7天达成率"
            },
            pod8_rate: {
              type: "string",
              description: "入库至签收8天达成率"
            },
            delivery9_rate: {
              type: "string",
              description: "入库至首派9天达成率"
            },
            pod10_rate: {
              type: "string",
              description: "入库至签收10天达成率"
            },
            pod5_rate: {
              type: "string",
              description: "创建至签收5天达成率"
            }
          }
        },
        delivery_first: {
          list: apis.delivery_first,
          keys: {
            num: { type: "string", description: "单量number" },
            rate1: { type: "string", description: "签收delivered" },
            rate2: {
              type: "string",
              description: "地址变更 location change"
            },
            rate3: {
              type: "string",
              description: "预约派送on expect day"
            },
            rate4: {
              type: "string",
              description: "电话不响应No Respond"
            },
            rate5: {
              type: "string",
              description: "拒签Refused-Cancelled Order"
            },
            rate6: {
              type: "string",
              description: "拒签Refused-Checked the package"
            },
            rate7: {
              type: "string",
              description: "拒签Refused-Delay Order"
            },
            rate8: {
              type: "string",
              description: "拒签Refused-No Cash"
            },
            rate9: {
              type: "string",
              description: "拒签Refused-no order was placed"
            },
            rate10: {
              type: "string",
              description: "拒签Refused-payment price different"
            },
            rate11: {
              type: "string",
              description: "拒签Refused-request to open"
            },
            rate12: {
              type: "string",
              description: "电话错误Incorrect phone number"
            },
            rate13: {
              type: "string",
              description: "拦截Intercept as shipper requested"
            },
            rate14: {
              type: "string",
              description: "地址不详Incomplete address"
            },
            rate16: {
              type: "string",
              description: "下一次派送Next delivery cycle"
            },
            rate15: { type: "string", description: "其他" },
            rate0: { type: "string", description: "未更新结果" }
          }
        },
        delivery_new: {
          list: apis.delivery_new,
          keys: {
            num: { type: "string", description: "单量number" },
            rate1: { type: "string", description: "签收delivered" },
            rate2: {
              type: "string",
              description: "地址变更 location change"
            },
            rate3: {
              type: "string",
              description: "预约派送on expect day"
            },
            rate4: {
              type: "string",
              description: "电话不响应No Respond"
            },
            rate5: {
              type: "string",
              description: "拒签Refused-Cancelled Order"
            },
            rate6: {
              type: "string",
              description: "拒签Refused-Checked the package"
            },
            rate7: {
              type: "string",
              description: "拒签Refused-Delay Order"
            },
            rate8: {
              type: "string",
              description: "拒签Refused-No Cash"
            },
            rate9: {
              type: "string",
              description: "拒签Refused-no order was placed"
            },
            rate10: {
              type: "string",
              description: "拒签Refused-payment price different"
            },
            rate11: {
              type: "string",
              description: "拒签Refused-request to open"
            },
            rate12: {
              type: "string",
              description: "电话错误Incorrect phone number"
            },
            rate13: {
              type: "string",
              description: "拦截Intercept as shipper requested"
            },
            rate14: {
              type: "string",
              description: "地址不详Incomplete address"
            },
            rate16: {
              type: "string",
              description: "下一次派送Next delivery cycle"
            },
            rate15: { type: "string", description: "其他" },
            rate0: { type: "string", description: "未更新结果" }
          }
        },
        status: {
          list: apis.status,
          keys: {
            cn_status_num: { type: "string", description: "国内段" },
            lj_status_num: { type: "string", description: "全段_拦截" },
            ck_status_num: { type: "string", description: "出口关" },
            il1_status_num: {
              type: "string",
              description: "国际干线运输_下港"
            },
            il5_status_num: {
              type: "string",
              description: "国际干线运输_到港"
            },
            il2_status_num: {
              type: "string",
              description: "国际干线运输_交航"
            },
            il3_status_num: {
              type: "string",
              description: "国际干线运输_起飞"
            },
            il4_status_num: {
              type: "string",
              description: "国际干线运输_抵达"
            },
            jk_status_num: { type: "string", description: "进口关" },
            d1_status_num: { type: "string", description: "末端派送段_未首派" },
            d2_status_num: {
              type: "string",
              description: "末端派送段_已首派"
            },
            pod_status_num: { type: "string", description: "签收_闭环" },
            df1_status_num: {
              type: "string",
              description: "派送失败_退件中"
            },
            df2_status_num: {
              type: "string",
              description: "派送失败_闭环"
            },
            df3_status_num: {
              type: "string",
              description: "物流异常_闭环"
            },
            outbound_num: { type: "string", description: "出库数量" },
            status_num: { type: "string", description: "总计" },
            first_140_rate: { type: "string", description: "首派率" },
            first_pod_rate: { type: "string", description: "首派签收率" },
            pod_rate: { type: "string", description: "总签收率" },
            performance_140_rate: {
              type: "string",
              description: "首派结果履约达成率"
            },
            performance_112_rate: {
              type: "string",
              description: "清关履约率"
            },
            performance_pod_rate: {
              type: "string",
              description: "签收履约达成率"
            },
            loop_rate: { type: "string", description: "闭环率" },
            return_rate: { type: "string", description: "退件预警" }
          }
        },
        tracker: {
          list: apis.tracker,
          keys: {
            num: { type: "string", description: "订单数量" },
            awl_rate: { type: "string", description: "发运仓入库" },
            shk_rate: { type: "string", description: "发运仓出库" },
            ahk_rate: { type: "string", description: "到香港/机场" },
            alw_rate: { type: "string", description: "交航" },
            "110_rate": { type: "string", description: "起飞" },
            "111_rate": { type: "string", description: "抵达" },
            ccs_rate: { type: "string", description: "清关开始" },
            "112_rate": { type: "string", description: "清关完成" },
            "113_rate": { type: "string", description: "清关交付" },
            c_rate: { type: "string", description: "目的国入仓" },
            "140_rate": { type: "string", description: "首派" },
            pod_rate: { type: "string", description: "闭环" }
          }
        },
        pickup: {
          list: apis.pickup,
          keys: {
            num: { type: "string", description: "订单数量" },
            "144_rate": { type: "string", description: "首次上门揽收" },
            "148_rate": { type: "string", description: "取件成功" },
            rtsg_rate: { type: "string", description: "退回送仓" }
          }
        }
      },
      header: [
        {
          key: "statType",
          placeholder() {
            return this.$tz("统计,维度");
          },
          component: "Select",
          options: [],
          optionsFn: "",
          optionsKey: "ANALYZE_DATE_SELECT_TYPE",
          noAuto: true
        },
        {
          key: "dataType",
          placeholder() {
            return this.$tz("时间维度");
          },
          component: "Select",
          options: [],
          optionsFn: "",
          optionsKey: "GCC_STAT_SELECT_TYPE",
          noAuto: true
        },
        {
          key: "startTime",
          placeholder() {
            return this.$tz("请选择,开始,日期");
          },
          component: "DatePicker",
          bind: {
            options: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            style: {
              width: "150px"
            }
          }
        },
        {
          key: "endTime",
          placeholder() {
            return this.$tz("请选择,结束,日期");
          },
          component: "DatePicker",
          bind: {
            options: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            style: {
              width: "150px"
            }
          },
          noAuto: true
        },
        {
          key: "client_id",
          placeholder() {
            return this.$tz("客户名称");
          },
          component: "Select",
          options: [],
          optionsFn: "getAllClient",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "pay_type",
          placeholder() {
            return this.$tz("支付类型");
          },
          component: "Select",
          options: [],
          optionsFn: "",
          optionsKey: "COD_TYPE",
          noAuto: true
        },
        {
          key: "order_type",
          placeholder() {
            return this.$tz("订单类型");
          },
          component: "Select",
          options: [],
          optionsFn: "",
          optionsKey: "ORDERS_TYPE",
          noAuto: true,
          bind: {
            multiple: true
          }
        },
        {
          key: "deliver",
          placeholder() {
            return this.$tz("派送商");
          },
          component: "Select",
          options: [],
          optionsFn: "agent",
          optionsKey: "",
          bind: {
            multiple: true
          }
        },
        {
          key: "from_country",
          placeholder() {
            return this.$tz("起运国家");
          },
          component: "Select",
          options: [],
          optionsFn: "formCountry",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "to_country",
          placeholder() {
            return this.$tz("目的国家");
          },
          component: "Select",
          options: [],
          optionsFn: "toCountry",
          optionsKey: "",
          noAuto: true,
          methods: {
            "on-change"({ searchForm }) {
              searchForm.province = [];
              this.handleRequestMethods("getProvince", {
                country: searchForm.to_country
              }).then(res => {
                this.header.searchs.forEach(t => {
                  if (t.key === "province") t.options = res.payload;
                });
              });
            }
          }
        },
        {
          name: this.$tz("省份"),
          key: "province",
          component: "Select",
          placeholder: () => this.$tz("省份"),
          options: [],
          optionsFn: "",
          optionsKey: "",
          default: [],
          bind: {
            multiple: true
          }
        },
        {
          key: "from_port",
          component: "Select",
          placeholder: () => this.$tz("起运机场"),
          options: [],
          optionsFn: "getAirPort",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "to_port",
          placeholder() {
            return this.$tz("目的机场");
          },
          component: "Select",
          options: [],
          optionsFn: "getAirPort",
          optionsKey: "",
          noAuto: true
        }
      ]
    };
  }
};
</script>

<style></style>
